import React, { useState, useEffect, useMemo } from "react";
import { Typography, Grid } from "@mui/material";
import CustomTable from "components/TableExplanded/Table";
import CustomPagination from "components/TableExplanded/Pagination";
import useProductData from "pages/Pawn/List/ListByCustomer/data/data";
import useColumns from "pages/Pawn/List/ListByCustomer/columns/mainColumns";
import useColumnsTwo from "pages/Pawn/List/ListByCustomer/columns/subColumns";
import Modal from "components/Modal/Pawn/Create/ModalInterest";
import ViewModal from "components/Modal/Pawn/View/ViewListByCustomer";
import SearchBar from "components/TableExplanded/SearchBar";
import SaveIcon from "@mui/icons-material/Save";

import { GradientButtonOutline } from "components/GradientButton";
import api from "_api";
import { useAuth } from "hooks/useAuth";
import ModalConfirm from "components/Modal/ModalConfirm";
import AlertToast from "components/AlertToast";

const ListByCustomer = ({ className }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isViewModalOpen, setViewModalOpen] = useState(false);
  const [selectedProduct, setProduct] = useState(null);
  const [viewProduct, setViewProduct] = useState(null);
  const [fetchData, setFetchData] = useState();
  const [searchQuery, setSearchQuery] = useState(""); // Store the search query
  const [dataLength, setDataLength] = useState(0);
  const [isModalAlert, setIsModalAlert] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const { user } = useAuth();

  const fetchProductData = async ({
    searchCode = "",
    searchIdcard = "",
    searchName = "",
    searchDate = "",
    page = 1,
    limit = 10,
  }) => {
    try {
      const { data, isStatus, total } = await api.product.getOrderByCustomerV2({
        searchCode,
        searchIdcard,
        searchName,
        searchDate,
        page,
        limit,
      });
      if (isStatus) {
        setFetchData(data);
        setDataLength(total); // Set the total data length for pagination
      }
    } catch (error) {
      console.error("Error fetching product data:", error);
    }
  };

  const DeleteOrder = async (values) => {
    try {
      const chageStatusOrder = await api.pawn.DeleteOrder(values);
      // console.log("data", values);
      console.log("chageStatusOrder", chageStatusOrder);
      if (chageStatusOrder)
        fetchProductData({
          searchCode: "",
          searchIdcard: "",
          searchName: "",
          searchDate: "",
          page: page + 1,
          limit: rowsPerPage,
        });
    } catch (error) {
      console.error("Error fetching product data:", error);
      const { response } = error;
      setIsModalAlert(true);
      setErrorMessage(response?.data?.message || "ไม่สามารถลบรายการนี้ได้");
    }
  };

  useEffect(() => {
    fetchProductData({
      searchCode: searchQuery,
      searchIdcard: "",
      searchName: "",
      searchDate: "",
      page: page + 1,
      limit: rowsPerPage,
    });
  }, [searchQuery, page, rowsPerPage]);

  // console.log("data display new data", fetchData);

  const handleModalOpen = () => {
    setModalOpen(!isModalOpen);
    if (selectedProduct && isModalOpen) setProduct(null);
  };

  const handleViewOpen = () => {
    setViewModalOpen(!isViewModalOpen);
    if (viewProduct && isViewModalOpen) setViewProduct(null);
  };

  const data = useProductData(fetchData);
  const columns = useColumns(
    setViewProduct,
    setProduct,
    handleViewOpen,
    handleModalOpen,
    DeleteOrder
  );
  const columnsInside = useColumnsTwo();
  const visibleColumns = columns.filter((col) => col.showInFilter);

  const handleSearchChange = (event) => {
    if (
      event &&
      event.target &&
      event.target.value !== undefined &&
      event.target.value !== null
    ) {
      const query = event.target.value.toLowerCase();
      setSearchTerm(query);
      setSearchQuery(query); // Update searchQuery with the search term
    } else {
      console.error("Event target or value is undefined");
    }
    setPage(0); // Reset page when search changes
  };

  const handleClear = () => {
    setSearchTerm("");
    setSearchQuery(""); // Reset searchQuery when clearing the search
    setPage(0); // Reset page when clearing search
    let filter = {
      searchCode: "",
      searchIdcard: "",
      searchName: "",
      searchDate: "",
      page: 1,
      limit: 10,
    };
    fetchProductData({
      ...filter,
    });
  };

  const handlePageChange = (event, newPage) => {
    if (searchTerm != null) {
      setSearchQuery(searchTerm.order_code);
    }
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // console.log("searchTerm", searchTerm);
  const handleExportExcel = async () => {
    await api.product
      .exportExcelListOrderByCustomer(user?.company_id)
      .then((res) => {
        const contentDisposition = res.headers["content-disposition"];
        let filename = "download.xlsx"; // Default กรณีไม่มีชื่อไฟล์จาก API

        if (contentDisposition) {
          const match = contentDisposition.match(/filename="?(.+?)"?$/);
          if (match && match[1]) {
            filename = match[1];
          }
        }

        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => {
        console.error("Error exporting excel:", error);
      });
  };

  return (
    <div className={className}>
      <Grid container spacing={2} style={{ marginBottom: "16px" }}>
        <Grid
          item
          xs={12}
          sm={12}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography component="div" style={{ fontSize: "32px" }}>
            รายการแยกตามชื่อลูกค้า
          </Typography>
          <Grid display={"flex"} style={{ gap: "8px" }}>
            <GradientButtonOutline
              onClick={handleExportExcel}
              sx={{
                px: 3,
                display: "flex",
                alignItems: "center",
                height: "48px",
              }}
            >
              <Typography style={{ marginRight: "8px" }}>
                ส่งออก Excel
              </Typography>
              <SaveIcon fontSize="medium" />
            </GradientButtonOutline>
          </Grid>
        </Grid>
      </Grid>

      <SearchBar
        columns={columns}
        searchTerm={setSearchTerm}
        visibleColumns={visibleColumns} // กรองคอลัมน์ที่ต้องการแสดง
        handleSearchChange={handleSearchChange}
        handleClear={handleClear}
        fetchData={fetchData}
        handleSearchClick={(filters) => {
          fetchProductData({
            searchCode: filters.order_code || "",
            searchIdcard: filters.idcard || "",
            searchName: filters.customer_name || "",
            searchDate: filters.created_date || "",
            page: 1,
            limit: rowsPerPage,
          });
        }}
        QRCode={false}
      />

      <CustomTable
        columns={columns}
        columnsInside={columnsInside}
        searchTerm={searchTerm}
        // data={filteredData.slice(
        //   page * rowsPerPage,
        //   page * rowsPerPage + rowsPerPage
        // )}
        setDataLength={setDataLength}
        page={page}
        rowsPerPage={rowsPerPage}
        data={data}
      />
      <CustomPagination
        count={dataLength}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
      />

      <Modal
        open={isModalOpen}
        onClose={handleModalOpen}
        selectedProduct={selectedProduct}
        fetchProductData={fetchProductData}
      />

      <ViewModal
        open={isViewModalOpen}
        onClose={handleViewOpen}
        selectedProduct={viewProduct}
      />

      {/* ลบไม่สำเร็จ */}
      <AlertToast
        open={isModalAlert}
        onClose={() => setIsModalAlert(false)}
        type="error"
        message={errorMessage}
      />
    </div>
  );
};

export default ListByCustomer;
